import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import styles from './styles.module.css'
import { useContext } from 'react'
import { AuditContext } from '../../../global/context/audit-context/AuditContext'
import SecondaryButton from '../../../global/components/buttons/secondary-button/SecondaryButton'
import { STATUS } from '../../../global/types/audit'
import AuditWorkOrderVehiclesTable from './tables/AuditWorkOrderVehiclesTable'
import AuditOverviewSummaryTable from './tables/AuditOverviewSummaryTable'
import AuditCancellationTable from './tables/AuditCancellationTable'

interface OrderDetailsModalProps {
  isOpen: boolean
  onClose: () => void
}

export default function AuditWorkOrderDetailsModal({
  isOpen,
  onClose,
}: OrderDetailsModalProps) {
  const { order, auditStatus } = useContext(AuditContext)

  const orderNote: string =
    order?.orderNotes && order.orderNotes.length > 0
      ? order.orderNotes.map((note) => note.content).join(' | ')
      : 'No note available'

  const isCancelledOnsite = auditStatus === STATUS.ON_SITE_CANCELLATION

  return (
    <Modal
      open={isOpen}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
      onClose={onClose}
    >
      <Box className={styles.orderDetailsModal}>
        <div className={styles.pageTitle}>Work Order Details</div>
        <div className={styles.modalContent}>
          <div className={styles.noteContainer}>
            <div className={styles.noteTitle}>Order Note</div>
            <div className={styles.noteContent}>{orderNote}</div>
          </div>
          <AuditOverviewSummaryTable />
          <AuditWorkOrderVehiclesTable />
          {isCancelledOnsite && <AuditCancellationTable />}
        </div>
        <div className={styles.footerContainer}>
          <SecondaryButton
            buttonName='Close'
            onClick={onClose}
          />
        </div>
      </Box>
    </Modal>
  )
}
